import getBuilderLocalizedValue from "@/i18n/get-builder-localized-value";
import { useLocale } from "@/libs/base/components/locale-provider";

interface AccordionHeaderProps {
  title: BuilderLocalizedValue | string;
  description: BuilderLocalizedValue | string;
}

export function AccordionHeader(props: AccordionHeaderProps) {
  const locale = useLocale();

  const title = getBuilderLocalizedValue(props.title, locale);
  const description = getBuilderLocalizedValue(props.description, locale);

  return (
    <div className="space-y-5 sm:space-y-9">
      <h2 className="text-display">{title}</h2>

      <hr className="border-black" />

      <p className="text-header">{description}</p>
    </div>
  );
}
